import reducer from './reducers';

export { default as feedbackSelectors } from './selectors';
export { default as feedbackOperations } from './operations';
export { default as feedbackTypes } from './types';

export default reducer;
